module.exports = __webpack_public_path__ + "static/be-logo-4bb8cd3fc0b28a43116664924cf0a469.jpg";